import React, { useState, useCallback, useEffect } from "react";
import { AutoComplete, MasterTable } from "../../components/_index";
import {
  deleteCategory,
  getCategory,
  getRole,
} from "../../services/category.service";
import { Box, Button, Grid, Grid2, Stack, Typography } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
import AddCategory from "./AddCategory";

const Category = () => {
  const [data, setData] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const dispatch = useDispatch();
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    departmentRoleId: "",
  });

  const GetCategoryData = async () => {
    try {
      const res = await getCategory(queryParam);
      console.log(res, "CR");
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          roleName: e.roleInfo?.name,
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetCategoryData();
  }, [
    queryParam.search,
    queryParam.sort,
    queryParam.limit,
    queryParam.page,
    queryParam.departmentRoleId,
  ]);

  const columns = [
    { id: "name", label: "Category Name" },
    { id: "description", label: "Description" },
    { id: "roleName", label: "Role Name" },
  ];

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleAdd = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };
  const handleView = (e) => {
    e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);
  const [department, setDepartment] = useState([]);
  console.log("departmentdepartment", department);
  const handleDelete = (e) => {
    setSelectedDataId(e._id);
    setConfirmDeleteOpen(true);
  };

  const deleteFunction = async () => {
    try {
      const res = await deleteCategory(selectedDataId);
      console.log(res, "RRR");
      setConfirmDeleteOpen(false);
      GetCategoryData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const GetCategoryDatas = async () => {
    try {
      const res = await getRole();
      console.log(res, "CR");
      const modifiedData =
        res?.data
          .filter(
            (e) =>
              e.name === "HR" ||
              e.name === "PROJECT MANAGER" ||
              e.name === "FEEDBACK-ADMIN" ||
              e.name === "IT SUPPORT"
          )
          .map((e) => ({
            ...e,
            label: e.name,
            id: e._id,
          })) || [];
      setDepartment([{ id: "", label: "All" }, ...modifiedData]);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetCategoryDatas();
  }, []);

  return (
    <div className="mainContent">
      <Box sx={{ display: "flex", justifyContent: "space-between" }} mb={2}>
        <Box className="SearchInputBoxContainer">
          <SearchOutlinedIcon className="Search_Icon" />
          <input
            className="SearchInputBox"
            placeholder="Search here"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Box>

        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={2}
          sx={{
            width: "400px",
          }}>
          <Stack
            sx={{
              width: "200px",
            }}>
            <AutoComplete
              options={department}
              value={
                queryParam.departmentRoleId
                  ? {
                      id: queryParam.departmentRoleId,
                      label:
                        department.find(
                          (d) => d.id === queryParam.departmentRoleId
                        )?.label || "",
                    }
                  : null
              }
              getOptionLabel={(option) => option.label}
              onChange={(e, v) => {
                setQueryParam((prev) => ({
                  ...prev,
                  departmentRoleId: v ? v.id : "",
                  page: 1,
                }));
              }}
              placeholder="Select Role"
            />
          </Stack>
          <Button onClick={handleAdd} className="addButton">
            <AddIcon />
            Add Category
          </Button>
        </Stack>
      </Box>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        // handleView={handleView}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />
      {openDrawer ? (
        <AddCategory
          open={openDrawer}
          setOpenDrawer={setOpenDrawer}
          selectedData={selectedData}
          handleCloseDrawer={handleCloseDrawer}
          formType={
            selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
          }
          // formType={selectedData._id ? "edit" : "add"}
          GetCategoryData={GetCategoryData}
        />
      ) : null}
      <ConfirmBox
        open={confirmDeleteOpen}
        title="Are you sure you want to delete?"
        content={`You are about to delete this item`}
        confirmButton={"Delete"}
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default Category;
